import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
export class ManageReport extends HttpForm {
    report;
    title = 'Create Report';
    connections = [];
    middleware = [];
    models = [];
    data_types = [];
    field_types = [
        { value: 'text', name: 'Text' },
        { value: 'number', name: 'Number' },
        { value: 'date', name: 'Date' },
        { value: 'time', name: 'Time' },
        { value: 'datetime', name: 'DateTime' },
        { value: 'select', name: 'Select' },
    ];
    join_types = [
        { value: 'inner_join', name: 'INNER' },
        { value: 'left_join', name: 'LEFT' },
        { value: 'right_join', name: 'RIGHT' },
    ];
    data = {
        active: true,
        admin_only: false,
        connection: 'mysql',
        description: null,
        display_limit: 25,
        groupby: null,
        having: null,
        name: null,
        orderby: null,
        show_data: true,
        show_totals: false,
        table: null,
        where: null,
        middleware: [],
        fields: [],
        selects: [],
        joins: [],
    };
    constructor(params) {
        super();
        this.report = params.report;
    }
    mount() {
        if (this.report) {
            this.loadSettings().then(() => {
                this.getReport(this.report).then(() => {
                    this.setLoadingState(true);
                });
            }).catch(e => this.setError(e));
        }
        else {
            this.loadSettings().then(result => this.setLoadingState(result)).catch(e => this.setError(e));
        }
    }
    loadSettings() {
        let self = this;
        return new Promise((resolve, reject) => {
            axios.get('/api/report/manage/settings')
                .then(response => {
                self.connections = response.data.connections;
                self.middleware = response.data.middleware;
                self.models = response.data.models;
                self.data_types = response.data.data_types;
                resolve(true);
            }).catch(error => reject(error));
        });
    }
    submitReport() {
        this.setupFormSubmission();
        if (this.data.id) {
            const url = '/api/report/manage/' + this.data.id;
            return axios.patch(url, this.data).then(() => this.setSuccessMessage('Report `' + this.data.name + '` Updated')).catch(e => this.setError(e));
        }
        const url = '/api/report/manage';
        return axios.post(url, this.data).then(() => this.setSuccessMessage('Report `' + this.data.name + '` Created')).catch(e => this.setError(e));
    }
    getReport(id) {
        const url = '/api/report/manage/' + id;
        return axios.get(url).then((response) => {
            this.data = response.data.data;
        }).catch(e => this.setError(e));
    }
    hasMiddleware() {
        return this.data.middleware.length > 0;
    }
    hasFields() {
        return this.data.fields.length > 0;
    }
    hasSelects() {
        return this.data.selects.length > 0;
    }
    hasJoins() {
        return this.data.joins.length > 0;
    }
    addMiddleware() {
        this.data.middleware.push({
            id: null,
            middleware: null,
            deleted_at: null
        });
        return true;
    }
    removeMiddleware(index) {
        this.data.middleware[index].deleted_at = this.getTimestamp();
        return true;
    }
    addField() {
        this.data.fields.push({
            alias: "",
            deleted_at: null,
            id: 0,
            label: "",
            model: null,
            model_select_name: null,
            model_select_value: null,
            type: 'text'
        });
        return true;
    }
    removeField(index) {
        this.data.fields[index].deleted_at = this.getTimestamp();
        return true;
    }
    addSelect() {
        this.data.selects.push({
            alias: "",
            column: "",
            column_order: this.data.selects ? this.data.selects.length + 1 : 1,
            deleted_at: null,
            id: 0,
            type: this.data_types[0].value
        });
        return true;
    }
    moveSelectUp(index) {
        let previousSelect = this.data.selects[index - 1];
        let select = this.data.selects[index];
        if (previousSelect && select) {
            this.data.selects[index - 1].column_order = previousSelect.column_order + 1;
            this.data.selects[index].column_order = select.column_order - 1;
            let element = this.data.selects[index];
            this.data.selects.splice(index, 1);
            this.data.selects.splice(index - 1, 0, element);
        }
        return true;
    }
    moveSelectDown(index) {
        let nextSelect = this.data.selects[index + 1];
        let select = this.data.selects[index];
        if (nextSelect && select) {
            this.data.selects[index + 1].column_order = nextSelect.column_order - 1;
            this.data.selects[index].column_order = select.column_order + 1;
            let element = this.data.selects[index];
            this.data.selects.splice(index, 1);
            this.data.selects.splice(index + 1, 0, element);
        }
        return true;
    }
    removeSelect(index) {
        this.data.selects[index].deleted_at = this.getTimestamp();
        return true;
    }
    addJoin() {
        this.data.joins.push({
            deleted_at: null,
            first: "",
            id: 0,
            operator: "=",
            second: "",
            table: "",
            type: 'left_join'
        });
        return true;
    }
    removeJoin(index) {
        this.data.joins[index].deleted_at = this.getTimestamp();
        return true;
    }
}
